import { OP_STATUS } from '../../util/varibles/constants';
import styles from './style.module.scss';

interface IProps {
    visible?: boolean;
    className?: string;
    operation?: {
        operation_code: string;
    };
    code?: string
    status: OP_STATUS;
    prefix?: string
}

export default function Id({
    visible = true,
    className = '',
    operation,
    status,
    code,
    prefix = '#'
}: IProps) {
    if (!visible) return null;

    return (
        <div
            className={`${styles.id} ${className}`}
            data-status={status}
        >
            {prefix}{code || operation?.operation_code}
        </div>
    );
}